export const activityTypes = [
  {
    type: 'Visit',
    icon: 'home',
    cssClass: 'visit',
  },
  {
    type: 'Contact Comments',
    icon: 'comment',
    cssClass: 'comment',
  },
  {
    type: 'Email Sent',
    icon: 'email',
    cssClass: 'email',
  },
  {
    type: 'Email Received',
    icon: 'email',
    cssClass: 'email',
  },
  {
    type: 'Email Sent via 3rd Party',
    icon: 'email',
    cssClass: 'email',
  },
  {
    type: 'Text Sent',
    icon: 'stay_primary_portrait',
    cssClass: 'texts',
  },
  {
    type: 'Inbound Call',
    icon: 'phone',
    cssClass: 'call',
  },
  {
    type: 'Outbound Click to Call',
    icon: 'phone',
    cssClass: 'call',
  },
  {
    type: 'Lead Assigned',
    icon: 'contact_phone',
    cssClass: 'lead',
  },
  {
    type: 'LoneWolf Transaction zipForm',
    icon: '$vuetify.icons.lonewolf',
    cssClass: 'loneWolfTransaction',
  },
  {
    type: 'LoneWolf Transaction TransactionDesk',
    icon: '$vuetify.icons.lonewolf',
    cssClass: 'loneWolfTransaction',
  },
  {
    type: 'SMS Not Delivered',
    icon: 'error_outline',
    cssClass: 'smsNotDelivered',
  },
  {
    type: 'SMS Invalid Mobile Number',
    icon: 'error_outline',
    cssClass: 'smsNotDelivered',
  },
  {
    type: 'SMS Not Delivered - No Registration Found',
    icon: 'error_outline',
    cssClass: 'smsNotDelivered',
  },
  {
    type: 'SMS Not Sent',
    icon: 'error_outline',
    cssClass: 'smsNotDelivered',
  },
  {
    type: 'Cloud CMA',
    icon: '$vuetify.icons.cloud-cma',
    cssClass: 'cloudCMA',
  },
  {
    type: 'Contact Owner Changed',
    icon: 'person',
    cssClass: 'ownerChanged',
  },
  {
    type: 'Qualify Lead Created',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Lead Updated',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Rep Note',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify User Note',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Lead Unclaimed',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Lead Claimed',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Appointment Set',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Status Update',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Rep Text Sent',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Lead Deleted',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Qualify Outbound SMS',
    icon: '$vuetify.icons.qualify',
    cssClass: 'qualify',
  },
  {
    type: 'Email Not Delivered',
    icon: 'error_outline',
    cssClass: 'smsNotDelivered',
  },
];
